import { render } from "./BenefitForm.vue?vue&type=template&id=ea9d91ac&scoped=true"
import script from "./BenefitForm.vue?vue&type=script&lang=js"
export * from "./BenefitForm.vue?vue&type=script&lang=js"

import "./BenefitForm.vue?vue&type=style&index=0&id=ea9d91ac&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9d91ac"]])

export default __exports__